import { render, staticRenderFns } from "./PaymentVoidButton.vue?vue&type=template&id=c9d31d7a"
import script from "./PaymentVoidButton.vue?vue&type=script&lang=ts"
export * from "./PaymentVoidButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports